(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminSpillageEditSettingsController', AdminSpillageEditSettingsController);

    function AdminSpillageEditSettingsController(
        $controller,
        $state,
        messenger,
        moment,
        lodash,
        apiClient,
        settingsCollection,
        siteAssociateTypesCollection,
        elbSettings,
        module,
        fileTypeService
    ) {
        const vm = this;
        const base = $controller('AdminEditSettingsController', {
            $state: $state,
            messenger: messenger,
            moment: moment,
            lodash: lodash,
            apiClient: apiClient,
            settingsCollection: settingsCollection,
            settingsFields: [
                'spillage_open_chase_freq_before',
                'spillage_open_chase_freq_after',
                'spillage_accepted_chase_freq_before',
                'spillage_accepted_chase_freq_after',
                'spillage_in_progress_chase_freq_before',
                'spillage_in_progress_chase_freq_after',
                'spillage_escalation_interval_repeat',
                'spillage_escalation_interval',
                'spillage_escalation_siteassociate_type'
            ],
            elbSettings: elbSettings,
            module: module,
            fileTypeService: fileTypeService,
            validateTabSettings: null,
            buildTabSettingFormTypes: () => ({
                'spillage_open_chase_freq_before': { type: 'number', options: { invalid: false} },
                'spillage_open_chase_freq_after': { type: 'number', options: { invalid: false} },
                'spillage_accepted_chase_freq_before': { type: 'number', options: { invalid: false} },
                'spillage_accepted_chase_freq_after': { type: 'number', options: { invalid: false} },
                'spillage_in_progress_chase_freq_before': { type: 'number', options: { invalid: false} },
                'spillage_in_progress_chase_freq_after': { type: 'number', options: { invalid: false} },
                'spillage_escalation_interval_repeat': { type: 'number', options: { invalid: false} },
                'spillage_escalation_interval': { type: 'number', options: { invalid: false} },
                'spillage_escalation_siteassociate_type': { type: 'select-widget', model: null }
            })
        });

        angular.extend(vm, base);

        if (lodash.has(siteAssociateTypesCollection, 'siteAssociateTypes')) {
            let associateType;

            associateType = vm.settings.spillage_escalation_siteassociate_type;

            vm.siteAssociateTypesSelect = {
                response: siteAssociateTypesCollection,
                link: siteAssociateTypesCollection._links.self.href,
                responseKeyPath: 'siteAssociateTypes',
                required: true,
                onSelect: updateSiteAssociateType
            };

            if (associateType) {
                const selectedAssociateType = lodash.find(siteAssociateTypesCollection.siteAssociateTypes, function(element) {
                    return element.id === associateType.value;
                });

                if (typeof selectedAssociateType !== 'undefined') {
                    vm.siteAssociateTypesSelect.selected = {
                        object: selectedAssociateType,
                        href: selectedAssociateType._links.self.href,
                        value: selectedAssociateType.name
                    };
                }
            }

            if (vm.settingFormTypes && vm.settingFormTypes['spillage_escalation_siteassociate_type']) {
                vm.settingFormTypes['spillage_escalation_siteassociate_type'].model = vm.siteAssociateTypesSelect;
            }
        }

        function updateSiteAssociateType() {
            const associateValue = parseInt(lodash.replace(vm.siteAssociateTypesSelect.selected.href, '/siteassociatetypes/', ''));

            if (lodash.has(vm.settings.spillage_escalation_siteassociate_type, 'value')) {
                vm.settingsForm.spillage_escalation_siteassociate_type = associateValue;
            }
        }
    }
})();
